export interface DocumentLike {
    url: string;
    extension: string;
    file_name?: string;
    name?: string;
}

/**
 * Some rows in DB already store the extension inside file_name/name
 * (e.g. "plan.pdf") while others don't (e.g. "plan"). Concatenating
 * `${name}.${extension}` blindly produces "plan.pdf.pdf" for the first
 * case. This builds the final, de-duplicated URL either way.
 */
export function buildDocumentUrl(baseUrl: string, doc?: DocumentLike | null): string {
    if (!doc || !doc.url || !doc.extension) {
        return '';
    }

    const base = doc.file_name || doc.name || '';
    const suffix = `.${doc.extension.replace(/^\./, '')}`;
    const fileName = base.toLowerCase().endsWith(suffix.toLowerCase()) ? base : `${base}${suffix}`;

    return `${baseUrl}${doc.url}${fileName}`.replace(/([^:]\/)\/+/g, '$1');
}
